/**
 * LOS MENÚS DE UN DÍA, LISTOS PARA ENSEÑAR (Jesús, 31-10): la app prepara el día al enviar
 * el cuestionario, y quien acaba de terminarlo debe poder verlo sin salir a Nutrición.
 *
 * Solo salen las comidas con alimentos: el perientreno no se monta solo, y en bloque único
 * el día puede volver vacío. Sin ninguna, la pantalla no ofrece ver nada.
 */
import { num1 } from './numeros';
import { cantidadConNombre } from './cantidadConNombre';

const nombreDeLaComida = (clave, unica) => {
    if (clave.toLowerCase().startsWith('peri')) return 'Perientreno';
    return unica ? 'Comida única' : clave.replace('C', 'Comida ');
};

const alimentoConCantidad = (a) => {
    const conNombre = cantidadConNombre(a);
    if (conNombre) return `${conNombre} ${a.nombre}`;
    return `${num1(Math.round(a.cantidad_g || 0))} ${a.es_liquido ? 'ml' : 'g'} ${a.nombre}`;
};

export const menusDelDia = (dia) => Object.entries(dia?.comidas || {})
    .filter(([, comida]) => (comida?.alimentos || []).length)
    .sort(([a], [b]) => a.localeCompare(b))
    .map(([clave, comida]) => ({
        clave,
        nombre: nombreDeLaComida(clave, dia?.num_comidas === 1),
        menuNombre: comida.menu_nombre || null,
        alimentos: comida.alimentos.map(alimentoConCantidad).join(' · '),
    }));
